import React from 'react';
import {
  Grid,
  makeStyles,
  Checkbox,
  Link
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import '../listItem.component.scss';
import DisplayDate from '../displayDate/displayDate';
import { PRODUCTS, useCommonAuth } from '../../../submodule';
import { capitalize } from '../../../utils/common';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  rounded: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #9D9D9D`,
    color: '#9D9D9D',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  listItem: {
    color: '#434343',
    border: '1px solid #ededed',
    alignItems: 'center',
  },
}));

const OrganizationList = ({
  entityData,
  index,
  listData,
  setListData,
  handleInlineStatusChange,
  setChangeIndex,
  setShowModal,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const {userModulePermissions} = useCommonAuth();

  function handleChange(event) {
    const data = [...listData];

    data.forEach((item, index) => {
      if (item.PK + '_' + item.SK === event.target.value) {
        data[index].checked = event.target.checked;
      }
      return item;
    });
    setListData(data);
  }

  function handleStatus(event) {
    let item = { ...entityData };
    if (event.target.checked === true) {
      item.current_status = 'APPROVED';
    } else {
      item.current_status = 'DRAFT';
    }

    handleInlineStatusChange(item);
  }
  return (
    <Grid
      container
      className={classes.listItem}
      style={{ wordBreak: 'break-all' }}
    >
      <Grid item xs={'auto'} style={{ padding: '0 20px' }}>
        {false && (<Grid container spacing={1} style={{ padding: '10px 0 20px 0' }}>
          <Grid item xs={12}>
            <Checkbox
              name="checkedD"
              color="primary"
              data-testid="checkedD"
              value={`${entityData.PK}_${entityData.SK}`}
              checked={
                entityData.checked && entityData.checked === true ? true : false
              }
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>)}
      </Grid>
      <Grid item xs={11}>
        <Grid container spacing={1} style={{ padding: '20px 0' }}>
          <Grid item xs={12} className="textItemTitle">
            <Link style={{cursor: 'pointer'}} onClick={() => { history.push(`organization/${encodeURIComponent(entityData.PK)}`) }}>
              {entityData.shortname} - {entityData.title}
            </Link>
            <br />
          </Grid>
          <Grid item sm={12}>
            <Grid container alignItems='center'>
              <Grid item sm={3}>
                <DisplayDate
                  label="Effective Date"
                  date={
                    entityData.effectivedate ? entityData.effectivedate : null
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <DisplayDate
                  label="End Date"
                  date={
                    entityData.effectivedate ? entityData.inactivedate : null
                  }
                />
              </Grid>
              <Grid item sm={2}>
                ZipCode: {entityData.zipcode}
              </Grid>
              <Grid item sm={2}>
                Domain: {entityData?.config?.allowed_domains
                  ?.map((item) => item.domain)
                  ?.join(',') || 'N/A'}
              </Grid>
              <Grid item sm={2}>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      data-testid="current_status_lable"
                      control={
                        <Switch
                          color="primary"
                          name="current_status"
                          data-testid="current_status"
                          checked={
                            entityData.current_status == 'APPROVED'
                              ? true
                              : false
                          }
                          onChange={(event) => userModulePermissions('organization', 'edit', PRODUCTS.MAINAPP) ? handleStatus(event) : ''}
                          // disabled={!checkUserHasAccessForPath('users', 'edit')}
                        />
                      }
                      label={capitalize(entityData.current_status)}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item sm={4}>
                Product - {entityData.products?.map(item=>item.title).join(', ') || 'N/A'}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationList;
